    import React, { useState }                      from 'react';
    import SfondoLogin                              from '../images/sfondoLogin.png';
    import MailOutlineIcon                          from "@mui/icons-material/MailOutline"; 
    import { useTranslation }                       from 'react-i18next';
    import axios                                    from 'axios';
    import { useNavigate }                          from 'react-router-dom';
    import { Box, 
        Button, 
        Container, 
        Divider, 
        InputAdornment, 
        TextField, 
        Typography, 
        Snackbar, 
        Alert } from '@mui/material';


    

    const ForgotPasswordComponent = () => {


    const [email,     setEmail    ] = useState("");
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // "success", "error", "warning", "info"

    const {t, i18n} = useTranslation();
    const navigate = useNavigate();


    const showSnackbar = (message, severity = "success") => {
        setSnackbarMessage(message);
        setSnackbarSeverity(severity);
        setSnackbarOpen(true);
    };



    const handleForgotPassword = async (e) => {
        e.preventDefault();
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            showSnackbar(t("Inserire una mail valida"), "warning");
            return;
        }
        try {
        const response = await axios.post("http://localhost:8080/api/auth/lost/password", {
            email,
        });
        if(response.status === 200) {
            showSnackbar(t("Email inviata correttamente"), "success");
            setTimeout(() => {
                navigate("/login");
            }, 1500); 
            } else {
            showSnackbar(t("Errore nel recupero della mail"), "error");
            }
        } catch (error) {
        console.error("Error during password recovery:", error);

        const messageFromServer =
        error.response?.data?.message || "Errore nel recupero della mail";

        showSnackbar(messageFromServer, "error");

        }
    };

    const handleReturnLogin = () => {
        navigate("/login");
    }
        
    return (
        <Box
        sx={{
            position: 'relative',
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        }}
        >
        {/* Immagine di sfondo */}
        <Box
            component="img"
            src={SfondoLogin}
            alt="Sfondo Login"  
            sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            zIndex: -1, 
            }}
        />

        {/* Box per il contenuto del LoginComponent */}
        <Box
            sx={{
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            borderRadius: '20px',
            p: 3,
            boxShadow: 3, 
            gap: 4,
            width: '40%'
            }}
        >
            <Container maxWidth='xl'
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: 'auto',
                        width: 'auto',
                        backgroundColor: 'rgba(255, 255, 255, 0.8)',
                        borderRadius: '20px',
                        boxShadow: 3,
                        position: 'relative', 
                        overflow: 'hidden',
                        flexDirection: 'column',
                        gap: 2
                    }}
                >
            <Typography sx={{ pt:4, fontWeight: 'bold', fontSize: '1em' }}>  {t('Trova il tuo account')} </Typography>
            <Divider sx={{ width: '100%' }} />            
            <Typography>{t("Inserisci l'e-mail per cercare il tuo account.")}</Typography>
            <TextField
            label={t('Email')}
                variant="filled"
                fullWidth
                required
                autoFocus
                value={email}
                onChange={(e) => {
                setEmail(e.target.value);
                }}
                sx={{ mb: 2, width: '70%' }}
                InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                    <MailOutlineIcon />
                    </InputAdornment>
                ),
                }}
                />
                <Divider sx={{ width: '100%' }} />    
                <Box
                sx={{ 
                    display: 'flex',
                    flexDirection: 'row',
                    gap: 2,
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    pb: 2
                }}>
                <Button
                onClick={handleReturnLogin}
                sx={{
                width: '90%',
                bgcolor: '#EFEFEF',
                fontWeight: 'bold',
                borderRadius: '40px',
                color: '#4b4f56',
                p: 2,
                '&:hover': {
                    bgcolor: '#EFEFEF',
                    transform: 'scale(1.02)',
                },
                }}
                >
                    {t('Annulla')}
                </Button>


                <Button
                onClick={handleForgotPassword}
                sx={{
                width: '90%',
                bgcolor: '#263F78',
                fontWeight: 'bold',
                borderRadius: '40px',
                color: 'white',
                p: 2,
                '&:hover': {
                    bgcolor: '#263F78',
                    transform: 'scale(1.02)',
                },
                }}>
                    {t('Cerca')}
                </Button>
                </Box>        

            </Container>
        </Box>
        <Snackbar
                open={snackbarOpen}
                autoHideDuration={3000}
                onClose={() => setSnackbarOpen(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                >
                <Alert onClose={() => setSnackbarOpen(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
                    {snackbarMessage}
                </Alert>
        </Snackbar>

        </Box>
    );
    };

    export default ForgotPasswordComponent;
